import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface ContractLogGroup {
    contract_id: number | string;
    client_name: string;
    count: number;
    last_message: string;
    last_date: string | null;
}

interface IndexChatBotLogProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class IndexChatBotLog extends React.Component<IndexChatBotLogProps> {

    @observable private contractGroups: ContractLogGroup[] = [];
    @observable private isLoaded = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        http.get('/api/chatbot_log/read').then((response) => {
            this.contractGroups = this.groupLogsByContract(this.extractLogs(response.data));
            this.isLoaded = true;
        }).catch(() => {
            this.isLoaded = true;
            this.contractGroups = [];
            toast.error("Error cargando logs del chatbot");
        });
    }

    private extractLogs = (data: any): any[] => {
        if (Array.isArray(data)) {
            return data;
        }
        if (Array.isArray(data?.response)) {
            return data.response;
        }
        if (Array.isArray(data?.response?.data)) {
            return data.response.data;
        }
        return [];
    }

    private getMessage = (log: any): string => {
        return log.user_message || log.message || '';
    }

    private getClientName = (log: any): string => {
        return log.client_name || '';
    }

    private groupLogsByContract = (logs: any[]): ContractLogGroup[] => {
        const grouped: { [key: string]: ContractLogGroup } = {};

        logs.forEach((log) => {
            const contractId = log.contract_id;
            if (contractId == null || contractId === '') {
                return;
            }

            const key = String(contractId);
            if (!grouped[key]) {
                grouped[key] = {
                    contract_id: contractId,
                    client_name: this.getClientName(log),
                    count: 0,
                    last_message: '',
                    last_date: null
                };
            }

            if (!grouped[key].client_name && this.getClientName(log)) {
                grouped[key].client_name = this.getClientName(log);
            }

            grouped[key].count += 1;

            const logDate = log.created_at ? new Date(log.created_at) : null;
            const currentLastDate = grouped[key].last_date ? new Date(grouped[key].last_date as string) : null;

            if (!currentLastDate || (logDate && logDate > currentLastDate)) {
                grouped[key].last_date = log.created_at || null;
                grouped[key].last_message = this.getMessage(log);
                if (this.getClientName(log)) {
                    grouped[key].client_name = this.getClientName(log);
                }
            }
        });

        return Object.values(grouped).sort((a, b) => {
            const dateA = a.last_date ? new Date(a.last_date).getTime() : 0;
            const dateB = b.last_date ? new Date(b.last_date).getTime() : 0;
            return dateB - dateA;
        });
    }

    private formatDate = (date: string | null): string => {
        if (!date) {
            return '-';
        }
        return new Date(date).toLocaleString('es-MX');
    }

    private truncateMessage = (message: string): string => {
        if (!message) {
            return '-';
        }
        return message.length > 60 ? message.substring(0, 60) + '...' : message;
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Chat Bot Logs</h4>
                                <p className="card-category">Conversaciones del chatbot agrupadas por contrato</p>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>Contrato</th>
                                                <th>Cliente</th>
                                                <th>Último mensaje</th>
                                                <th>Mensajes</th>
                                                <th>Última actividad</th>
                                                <th className="text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.contractGroups.length > 0 ? (
                                                    this.contractGroups.map((group, index) => {
                                                        return (
                                                            <Fragment key={index}>
                                                                <tr>
                                                                    <td>{group.contract_id}</td>
                                                                    <td>{group.client_name || '-'}</td>
                                                                    <td>{this.truncateMessage(group.last_message)}</td>
                                                                    <td>{group.count}</td>
                                                                    <td>{this.formatDate(group.last_date)}</td>
                                                                    <td className="td-actions text-right">
                                                                        {sessionService.canViewSection("Chat Bot Logs.view") &&
                                                                            <Link to={`/chatbot-logs/contrato/${group.contract_id}`}>
                                                                                <button style={{ margin: 5 }} type="button" className="btn btn-info">
                                                                                    <i className="material-icons">visibility</i>
                                                                                </button>
                                                                            </Link>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </Fragment>
                                                        )
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6} className="text-center">No hay logs registrados</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
